import { mountReactComponents } from '../lib/react_mount.jsx';
const componentContext = import.meta.glob('../components/frictionless/**/*.tsx');
import Rails from '@rails/ujs';
Rails.start();

mountReactComponents(componentContext);
